// Do not resend a protected or unchanged identifier, including stale form values.
export const prepareProfileUpdate = <T extends Record<string, any>>(
  data: T,
  canEditFiscalCode: boolean,
  originalFiscalCode?: string | null
) => {
  const body = { ...data };
  if (!canEditFiscalCode || body.fiscalCode === originalFiscalCode) {
    delete body.fiscalCode;
  }
  return body;
};
